<template>
  <div class="filter-box" v-show="visible">
    <div class="filter-content">
      <div class="search-form">
        <div class="form-item">
          <div class="form-label">人群名称：</div>
          <div class="form-value">
            <!-- size="small" -->
            <el-input
              style="width: 240px"
              v-model="form.name"
              placeholder="请输入人群名称"
              maxlength="20"
              show-word-limit
            ></el-input>
          </div>
        </div>
        <div class="form-item" style="margin-left: 20px">
          <div class="form-label">人群描述：</div>
          <div class="form-value">
            <!-- size="small" -->
            <el-input
              :style="'width:' + inputWidth + 'px'"
              v-model="form.description"
              placeholder="请输入人群描述"
              maxlength="50"
              show-word-limit
            ></el-input>
          </div>
        </div>
      </div>
      <div class="tip-line" style="margin-top: 10px">
        <img
          src="@/assets/images/new_icon_reminder.png"
          style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 0 4px 0 3px;
          "
        />
        <span style="color: #fe4d45"
          >注意：标签数据的用户范围为“开卡会员+已购用户”</span
        >
      </div>
      <div class="attr-box">
        <div class="attr-leftbigbox">
          <div class="search-line">
            <el-input
              v-model="searchValue"
              @keyup.enter.native="handleSearch"
              placeholder="请输入标签名称查询"
            ></el-input>
            <i class="el-icon-search" @click="handleSearch"></i>
          </div>
          <div class="attr-left">
            <div class="search-result" v-if="searchStatus">
              <span>查询结果</span>
              <span class="go-back" @click="goBack">
                返回
                <i class="el-icon-close"></i>
              </span>
            </div>

            <div
              class="attr-item-wrap"
              v-for="(item, index) in dataList"
              :key="'wrap' + index"
              v-show="item.searchWrap"
            >
              <h4>
                {{ item.firstLevelCategory }}
                <span style="color: #fe4d45; font-size: 13px">{{
                  item.labelCount
                }}</span>
              </h4>

              <div
                class="attr-item-box"
                v-for="(labelItem, labelIndex) in item.data"
                :key="labelIndex"
              >
                <div class="attr-title" v-show="labelItem.searchTitle">
                  {{ labelItem.secondLevelCategory }}
                  <img
                    v-if="labelItem.secondLevelCategory == '数量相关标签'"
                    src="@/assets/images/tag_new_x.png"
                    alt=""
                  />
                </div>

                <div class="attr-list">
                  <template v-for="(label, idx) in labelItem.data">
                    <div
                      class="attr-padd"
                      :key="'label' + idx"
                      v-if="label.searchItem && !label.isHide"
                    >
                      <div
                        class="attr-item"
                        v-labelZoom="{ name: label.labelMeaning }"
                        :class="{ active: label.valueData.visible }"
                        @click="attrClick(label, item, labelItem)"
                      >
                        <template v-if="label.labelMeaning.length >= 10">
                          <el-tooltip
                            effect="light"
                            :content="label.labelMeaning"
                            placement="top-start"
                          >
                            <div class="over-ellipsis">
                              <span class="icon-dot" v-if="label.isNew"></span>
                              {{ label.labelMeaning }}
                            </div>
                          </el-tooltip>
                        </template>
                        <template v-else>
                          <span class="icon-dot" v-if="label.isNew"></span>
                          {{ label.labelMeaning }}
                        </template>
                        <img alt src="@/assets/images/gou.png" />
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="attr-rightbigbox">
          <div class="tip-line" style="margin-bottom: 25px">
            <img
              src="@/assets/images/new_icon_reminder.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 0 4px 0 3px;
              "
            />
            <span
              >多个标签之间是且的关系，如需更灵活的人群交并差，可在营销时使用人群运算</span
            >
            <!-- <span style="color: #FE4D45">需要满足</span>
            <span>以下标签;标签之间取交集即为所选人群</span> -->
          </div>
          <div class="attr-right">
            <div
              style="text-align: center; margin-top: 80px"
              v-if="defaultShow == true"
            >
              <img src="@/assets/images/default/暂无任何商品.png" />
              <br />
              <span style="color: #999">请从左侧选取标签在此编辑</span>
            </div>
            <div
              v-for="(item, index) in dataList"
              :key="item.firstLevelCategory + index"
            >
              <div class="first-title" v-show="item.isShow">
                {{ item.firstLevelCategory }}
              </div>
              <div
                v-for="(labelItem, labelIndex) in item.data"
                :key="labelIndex"
              >
                <!-- <div class="module-title">{{labelItem.secondLevelCategory}}</div> -->
                <div
                  class="attr-content-item"
                  v-for="(label, idx) in labelItem.data"
                  :key="'label' + idx"
                >
                  <div v-if="label.valueData.visible">
                    <div class="title-line">
                      <span>{{ label.labelMeaning }}</span>
                      <div class="handle">
                        <el-popover
                          placement="top-start"
                          width="500"
                          trigger="hover"
                        >
                          <button slot="reference" class="assistant">
                            运营助手
                          </button>
                          <div class="popoverWrap">
                            <div class="popoverItem">
                              <img
                                src="@/assets/images/popover_label1.png"
                                class="icon"
                              />
                              <div class="desc">
                                <span>标签定义</span>
                                <span>{{ label.labelDefinition }}</span>
                              </div>
                            </div>
                            <div class="popoverItem">
                              <img
                                src="@/assets/images/popover_label2.png"
                                class="icon"
                              />
                              <div class="desc">
                                <span>运营建议</span>
                                <span>{{ label.labelSuggestion }}</span>
                              </div>
                            </div>
                            <div class="popoverItem">
                              <img
                                src="@/assets/images/popover_label3.png"
                                class="icon"
                              />
                              <div class="desc">
                                <span>时间范围</span>
                                <span>{{ label.labelSelectRange }}</span>
                              </div>
                            </div>
                          </div>
                        </el-popover>
                        <span
                          class="delTxt"
                          @click="delLabel(label, item, labelItem)"
                          >删除</span
                        >
                      </div>
                    </div>
                    <!-- 类型1 单选 radio  -->
                    <div
                      class="content radio-content"
                      v-if="label.labelDisplayType == 0"
                    >
                      <p class="labelExplain">{{ label.labelExplain }}</p>
                      <!-- <el-radio-group v-model="radio"> -->
                      <el-radio
                        v-for="(checkItem, checkIndex) in label.enumValues"
                        v-model="label.valueData.value"
                        :key="checkIndex"
                        :label="checkItem.realValue"
                        >{{ checkItem.fieldValue }}</el-radio
                      >
                      <!-- </el-radio-group> -->
                    </div>
                    <!-- 类型二 多选 checkbox -->
                    <div
                      class="content radio-content"
                      v-if="label.labelDisplayType == 1"
                    >
                      <p class="labelExplain">
                        {{ label.labelExplain | labelExplain }}
                        <span
                          style="color: red"
                          v-if="label.labelExplain.indexOf('</span>') != -1"
                          >（注：workday工作日，restday休息日）</span
                        >
                      </p>
                      <el-checkbox-group
                        @change="switchAllSelect(label)"
                        style="display: inline-block; margin-right: 20px"
                        v-if="label.labelName == 'opdata_shop_member_channel'"
                        v-model="allSelectMembel"
                      >
                        <el-checkbox label="-1">全选</el-checkbox>
                      </el-checkbox-group>
                      <el-checkbox-group
                        :style="{
                          display:
                            label.labelName == 'opdata_shop_member_channel'
                              ? 'inline'
                              : 'block',
                        }"
                        v-model="label.valueData.checkValue"
                        @change="switchAllSecletStatus(label)"
                      >
                        <el-checkbox
                          v-for="(checkItem, checkIndex) in label.enumValues"
                          :key="checkIndex"
                          :label="checkItem.realValue"
                          >{{ checkItem.fieldValue }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                    <!-- 类型三 区间范围选择器 -->
                    <div
                      class="content area-select"
                      v-if="label.labelDisplayType == 3"
                    >
                      <p class="labelExplain">{{ label.labelExplain }}</p>
                      <div style="margin-top: 14px">
                        <el-select
                          @change="rangeTypeChange(label)"
                          v-model="label.valueData.rangeType"
                        >
                          <el-option
                            v-for="(item, index) in areaSelect"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- v-only-number -->
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          v-if="label.valueData.rangeType != -1"
                          placeholder="起"
                          v-model="label.valueData.minValue"
                        ></el-input>
                        <span
                          v-if="label.valueData.rangeType == 0"
                          class="to-text"
                          >至</span
                        >
                        <!-- v-only-number -->
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          v-if="label.valueData.rangeType != 1"
                          placeholder="至"
                          v-model="label.valueData.maxValue"
                        ></el-input>
                      </div>
                    </div>
                    <!-- 类型四 选择省市 -->
                    <div
                      class="content select-city-box"
                      v-if="label.labelDisplayType == 7"
                    >
                      <p class="labelExplain">{{ label.labelExplain }}</p>
                      <el-button
                        style="margin-top: 14px"
                        @click="handleSelectCity(index, labelIndex, idx)"
                        >选择省市（{{
                          provinces && provinces.length
                        }}）</el-button
                      >
                    </div>
                    <!-- 类型五 指定商品 指定sku -->
                    <div
                      class="content goods-sku-box"
                      v-if="label.labelDisplayType == 5"
                    >
                      <p class="labelExplain">{{ label.labelExplain }}</p>
                      <!-- <el-radio-group v-model="labels"> -->
                      <el-radio :label="0" v-model="label.valueData.skuType">
                        <span>指定商品</span>
                        <el-button
                          style="margin-top: 14px"
                          @click="showSelectGoods(index, labelIndex, idx)"
                          :disabled="label.valueData.skuType != 0"
                          :style="{
                            color:
                              label.valueData.skuType == 0
                                ? globalBG
                                : '#C0C4CC',
                            'border-color':
                              label.valueData.skuType == 0
                                ? globalBG
                                : '#EBEEF5',
                          }"
                          >选择商品（{{
                            label.valueData.goodsList.length
                          }}）</el-button
                        >
                      </el-radio>
                      <el-radio :label="1" v-model="label.valueData.skuType">
                        <span>指定sku</span>
                        <el-input
                          type="text"
                          v-model.trim="label.valueData.value"
                          @input="limitSkuId(index, labelIndex, idx)"
                          placeholder="多个sku请用英文逗号隔开"
                        ></el-input>
                      </el-radio>
                      <!-- </el-radio-group> -->
                    </div>
                    <!-- 类型六 滑块组件 取值 -->
                    <div
                      class="content slider"
                      v-if="label.labelDisplayType == 2"
                    >
                      <p class="labelExplain">{{ label.labelExplain }}</p>
                      <el-slider
                        v-model="label.valueData.slideValue"
                        show-input
                      ></el-slider>
                    </div>
                    <!-- 类型七  商品类目-->
                    <div
                      class="content slider"
                      v-if="label.labelDisplayType == 6"
                    >
                      <p class="labelExplain">{{ label.labelExplain }}</p>
                      <el-button
                        style="margin-top: 14px; width: 120px"
                        @click="
                          showCategoryDialog(
                            index,
                            labelIndex,
                            idx,
                            label.valueData.value
                          )
                        "
                        >选择类目（{{
                          label.valueData.value.length
                        }}）</el-button
                      >
                    </div>
                    <!-- 类型八 时间范围选择器 -->
                    <div
                      class="content time-range"
                      v-show="label.labelDisplayType == 4"
                    >
                      <p class="labelExplain">{{ label.labelExplain }}</p>
                      <div style="margin-top: 14px">
                        <el-select
                          @change="timeTypeChange(label)"
                          v-model="label.valueData.rangeType"
                          style="width: 100px; margin-right: 20px"
                        >
                          <template
                            v-if="label.labelName == 'opdata_shop_ord_date'"
                          >
                            <el-option
                              v-for="(item, index) in areaSelectTime2"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </template>
                          <el-option
                            v-else-if="
                              label.labelName != 'opdata_shop_ord_date'
                            "
                            v-for="(item, index) in areaSelectTime"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 区间时间 -->
                        <div
                          class="my_select_time"
                          v-if="label.valueData.rangeType == 0"
                        >
                          <el-date-picker
                            prefix-icon="no_icon"
                            v-model="label.valueData.minTime"
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            @change="limitTimeRange(label)"
                            :picker-options="
                              pickerOptionsList[
                                'pickerOptions' + label.labelName + 'start'
                              ]
                            "
                            value-format="yyyy-MM-dd"
                            style="width: 120px"
                            class="time1"
                            :clearable="false"
                          ></el-date-picker>
                          <div class="time_to_text">至</div>
                          <el-date-picker
                            prefix-icon="no_icon"
                            v-model="label.valueData.maxTime"
                            @change="limitTimeRange(label)"
                            :picker-options="
                              pickerOptionsList[
                                'pickerOptions' + label.labelName + 'end'
                              ]
                            "
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 135px"
                            class="time2"
                            :clearable="false"
                          ></el-date-picker>
                          <i
                            class="el-icon-circle-close date_icon1"
                            @click="clearTime(index, labelIndex, idx)"
                          ></i>
                          <img
                            src="@/assets/images/select_date.svg"
                            alt
                            class="date_icon2"
                          />
                        </div>
                        <!-- 小于时间 -->
                        <el-date-picker
                          v-if="label.valueData.rangeType == 2"
                          prefix-icon="no_icon"
                          v-model="label.valueData.maxTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="pickerOptions"
                          value-format="yyyy-MM-dd"
                          style="width: 240px"
                          :clearable="false"
                        ></el-date-picker>
                        <!-- 大于时间 -->
                        <el-date-picker
                          v-if="label.valueData.rangeType == 1"
                          prefix-icon="no_icon"
                          v-model="label.valueData.minTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="pickerOptions"
                          value-format="yyyy-MM-dd"
                          style="width: 240px"
                          :clearable="false"
                        ></el-date-picker>
                        <!-- 日期 -->
                        <el-date-picker
                          v-if="label.valueData.rangeType == 4"
                          type="dates"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          v-model="label.valueData.value"
                          placeholder="选择一个或多个日期"
                        >
                        </el-date-picker>
                        <!-- 相对时间 -->
                        <span v-if="label.valueData.rangeType == 3">
                          <el-input
                            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                            placeholder="天"
                            v-model="label.valueData.minTime"
                            style="width: 125px"
                          ></el-input>
                          <span style="margin: 0 8px" class="to-text">至</span>
                          <el-input
                            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                            placeholder="天"
                            style="width: 125px"
                            v-model="label.valueData.maxTime"
                          ></el-input>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="footer-btn-box">
      <el-button class="computed-btn" @click="handlePeopleComputed"
        >计算人群</el-button
      >
      <div class="text-label">
        当前已选择
        <span :style="{ color: globalBG }">{{ selectLabelCount }}</span
        >个标签，所选条件人群人数为
        <span :style="{ color: globalBG }">{{ population }}</span
        >人
      </div>
      <el-button @click="handleSave" class="save-btn">保存</el-button>
      <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
    </div>
    <!-- 自定义城市弹窗 -->
    <city-popover
      v-model="cityShow"
      @on-change="getLocation"
      :checkedList="provinces"
    ></city-popover>
    <!-- 商品类目 -->
    <goods-category-dialog
      @on-close="closeCategory"
      v-model="goodsCategoryDialog"
      :goodsClass="goodsClass"
    ></goods-category-dialog>
    <!-- 选择商品弹窗 -->
    <select-goods
      v-if="goodsState"
      :isShow="goodsState"
      :selectGoods="returnSelectGoods"
      :skuSearch="true"
      @close="selectGoodsChange"
      :moduleType="true"
    ></select-goods>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CityPopover from "@/views/manage/components/city-popover";
import goodsCategoryDialog from "./goods-category-dialog";
import SelectGoods from "./selectGoodsMonitor2";
import { getLabel, compute } from "@/api/manage/memberLabelController";
import { addMemberCrowd } from "@/api/memberCrowd";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  components: {
    CityPopover,
    goodsCategoryDialog,
    SelectGoods,
  },
  filters: {
    labelExplain(value) {
      var result = value;
      if (value.indexOf("</span>") != -1) {
        // result = "根据客户近半年非大促期间的客户下单数据分析计算出偏好（注：workday工作日，restday休息日）";
        return result.split("<span")[0];
      }
      return result;
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.provinces = [];
        this.goodsClass = [];
        if (this.editData) {
          console.log(this.editData);
          this.form.name = this.editData.name;
          this.form.description = this.editData.description;
          this.form.precisionCrowdStrategyId = this.editData.precisionCrowdStrategyId;
          this.form.strategyId = this.editData.strategyId;
          // 拿到编辑条件
          const checkDataArr = JSON.parse(this.editData.strategy);
          // 返回条件每一项的名字
          const tagnames =
            checkDataArr && checkDataArr.map((item) => item.tagname);
          // 遍历标签数组，对比每一项的名字是否相等
          this.dataList.forEach((dataItem) => {
            dataItem.data.forEach((labelItem) => {
              labelItem.data.forEach((item) => {
                // 判断名字数组中是否存在当前item的名字
                if (tagnames.includes(item.labelName)) {
                  // 拿到当前item在编辑条件中的索引
                  console.log(item);
                  const index = tagnames.indexOf(item.labelName);
                  item.valueData.visible = true;
                  this.selectLabelCount++;
                  /**
                   * 内容回显
                   * labelDisplayType 对应的内容类型
                   * 0: 单选, 1: 多选, 2: 滑块取值, 3: 区间范围选择, 4: 时间范围选择, 5: 指定商品 指定sku, 6: 商品类目, 7: 选择省市
                   */
                  // console.log(item.labelDisplayType);
                  switch (item.labelDisplayType) {
                    case 0:
                      item.valueData.value = checkDataArr[index].value;
                      break;
                    case 1:
                      if (item.labelName == "opdata_shop_member_channel") {
                        // 会员入会渠道
                        var valueList =
                          checkDataArr[index].checkValue ||
                          checkDataArr[index].value;
                        if (valueList && valueList.length > 0) {
                          if (valueList.length == "74") {
                            this.allSelectMembel = ["-1"];
                          }
                          var delItem = [];
                          valueList.forEach((vItem, vIndex) => {
                            if (vItem == "2") {
                              valueList.push("2,3,995,998");
                              delItem = delItem.concat([
                                "2",
                                "3",
                                "995",
                                "998",
                              ]);
                            }
                            // if (
                            //   vItem == "2" ||
                            //   vItem == "3" ||
                            //   vItem == "995" ||
                            //   vItem == "998"
                            // ) {
                            //   valueList.splice(
                            //     this.arrayIndexOf("2", valueList),
                            //     1
                            //   );
                            //   valueList.splice(
                            //     this.arrayIndexOf("3", valueList),
                            //     1
                            //   );
                            //   valueList.splice(
                            //     this.arrayIndexOf("995", valueList),
                            //     1
                            //   );
                            //   valueList.splice(
                            //     this.arrayIndexOf("998", valueList),
                            //     1
                            //   );
                            // }
                            if (vItem == "212") {
                              valueList.push("212,213");
                              delItem = delItem.concat(["212", "213"]);
                            }

                            // if (vItem == "212" || vItem == "213") {
                            //   valueList.splice(
                            //     this.arrayIndexOf("212", valueList),
                            //     1
                            //   );
                            //   valueList.splice(
                            //     this.arrayIndexOf("213", valueList),
                            //     1
                            //   );
                            // }
                            if (vItem == "420") {
                              valueList.push("420,666");
                              delItem = delItem.concat(["420", "666"]);
                            }
                            // if (vItem == "420" || vItem == "666") {
                            //   valueList.splice(
                            //     this.arrayIndexOf("420", valueList),
                            //     1
                            //   );
                            //   valueList.splice(
                            //     this.arrayIndexOf("666", valueList),
                            //     1
                            //   );
                            // }
                            if (vItem == "1003") {
                              valueList.push("1003,1004,1234");
                              delItem = delItem.concat([
                                "1003",
                                "1004",
                                "1234",
                              ]);
                            }
                            // if (
                            //   vItem == "1003" ||
                            //   vItem == "1004" ||
                            //   vItem == "1234"
                            // ) {
                            //   valueList.splice(
                            //     this.arrayIndexOf("1003", valueList),
                            //     1
                            //   );
                            //   valueList.splice(
                            //     this.arrayIndexOf("1004", valueList),
                            //     1
                            //   );
                            //   valueList.splice(
                            //     this.arrayIndexOf("1234", valueList),
                            //     1
                            //   );
                            // }
                            if (vItem == "4021") {
                              valueList.push("4021,4022,4023,402");
                              delItem = delItem.concat([
                                "4021",
                                "4022",
                                "4023",
                                "402",
                              ]);
                            }

                            // if (
                            //   vItem == "4021" ||
                            //   vItem == "4022" ||
                            //   vItem == "4023"
                            // ) {
                            //   valueList.splice(
                            //     this.arrayIndexOf("4021", valueList),
                            //     1
                            //   );
                            //   valueList.splice(
                            //     this.arrayIndexOf("4022", valueList),
                            //     1
                            //   );
                            //   valueList.splice(
                            //     this.arrayIndexOf("4023", valueList),
                            //     1
                            //   );
                            // }

                            if (vItem == "4031") {
                              valueList.push("4031,403");
                              delItem = delItem.concat(["4031", "403"]);
                            }
                            // if (vItem == "4031" || vItem == "403") {
                            //   valueList.splice(
                            //     this.arrayIndexOf("4031", valueList),
                            //     1
                            //   );
                            //   valueList.splice(
                            //     this.arrayIndexOf("403", valueList),
                            //     1
                            //   );
                            // }

                            if (vItem == "4041") {
                              valueList.push("4041,4042,404");
                              delItem = delItem.concat(["4041", "4042", "404"]);
                            }
                            // if (vItem == "4041" || vItem == "4042") {
                            //   valueList.splice(
                            //     this.arrayIndexOf("4041", valueList),
                            //     1
                            //   );
                            //   valueList.splice(
                            //     this.arrayIndexOf("4042", valueList),
                            //     1
                            //   );
                            // }
                          });
                          delItem.forEach((delItem, delIndex) => {
                            valueList.splice(
                              this.arrayIndexOf(delItem, valueList),
                              1
                            );
                          });
                          item.valueData.checkValue = valueList;
                        }
                      } else {
                        item.valueData.checkValue =
                          checkDataArr[index].checkValue ||
                          checkDataArr[index].value;
                      }

                      break;
                    case 2:
                      item.valueData.slideValue =
                        checkDataArr[index].slideValue;
                      break;
                    case 3:
                      if (
                        checkDataArr[index].startValue &&
                        checkDataArr[index].endValue
                      ) {
                        item.valueData.rangeType = 0;
                      } else if (checkDataArr[index].startValue) {
                        item.valueData.rangeType = 1;
                      } else {
                        item.valueData.rangeType = -1;
                      }
                      item.valueData.minValue = checkDataArr[index].startValue;
                      item.valueData.maxValue = checkDataArr[index].endValue;
                      break;
                    case 4:
                      item.valueData.minTime = checkDataArr[index].startValue;
                      item.valueData.maxTime = checkDataArr[index].endValue;
                      item.valueData.rangeType = +checkDataArr[index]
                        .timeSelectType;
                      if (
                        checkDataArr[index].value &&
                        checkDataArr[index].value.length > 0
                      ) {
                        item.valueData.value = checkDataArr[index].value.split(
                          ","
                        );
                      }
                      break;
                    case 5:
                      if (
                        checkDataArr[index].itemInfo &&
                        checkDataArr[index].itemInfo.length > 0
                      ) {
                        item.valueData.skuType = 0;
                        item.valueData.goodsList = checkDataArr[index].itemInfo;
                        this.returnSelectGoods = checkDataArr[index].itemInfo;
                      } else {
                        item.valueData.skuType = 1;
                        item.valueData.value = checkDataArr[index].value.join(
                          ","
                        );
                      }
                      break;
                    case 6:
                      item.valueData.value = checkDataArr[index].value;
                      this.goodsClass = checkDataArr[index].value;
                      break;
                    case 7:
                      item.valueData.value = checkDataArr[index].value;
                      this.provinces = checkDataArr[index].value;
                      break;
                  }
                }
              });
            });
          });
        }
        //判断表格是否为空
        try {
          this.dataList.forEach((item) => {
            item.data.forEach((item1) => {
              item1.data.forEach((item2) => {
                if (item2.valueData.visible == true) {
                  throw new Error("End");
                } else {
                  this.defaultShow = true;
                }
              });
            });
          });
        } catch (e) {
          if (e.message === "End") {
            this.defaultShow = false;
          } else {
            this.defaultShow = true;
          }
        }
      }
    },
    shopInfo(newVal) {
      if (newVal) {
        console.log("this.shopInfo", this.shopInfo);
        this.shopMemberType = this.shopInfo.shopMemberType;
        this.getLabelList();
      }
    },
  },
  data() {
    return {
      labels: 0,
      fasle: false,
      form: {
        name: "",
        description: "",
      },

      dataList: [],
      isNewNum: 0,
      isSaveLocation: false,
      isShowNew: true,
      areaSelect: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "大于等于",
          value: 1,
        },
        {
          label: "小于等于",
          value: -1,
        },
      ],
      areaSelectTime: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "大于等于",
          value: 1,
        },
        {
          label: "小于等于",
          value: 2,
        },
        {
          label: "相对时间",
          value: 3,
        },
      ],
      areaSelectTime2: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "日期",
          value: 4,
        },
      ],
      defaultShow: true, //无内容时跳出提示图标
      valueData: {
        minValue: "",
        maxValue: "",
        rangeType: 0, // 区间范围的值 0: 区间 1:大于 -1：小于
        slideValue: 0, // 滑动组件的值
        minTime: "",
        maxTime: "",
        itemInfo: [], // 商品信息
        skuType: 0, // 0. 指定商品 1.指定sku
        checkValue: [], // sku的值
        value: "",
        visible: false,
        goodsList: [],
      },
      allSelectMembel: [], // 会员入会渠道标签全选
      cityShow: false,
      provinces: [],
      goodsClass: [], //商品类目
      goodsCategoryDialog: false,
      searchStatus: false, // 是否为查询状态
      searchValue: "", // 查询值
      goodsState: false,
      returnSelectGoods: [],
      currentIndex: [], // 第一个值表示dataIndex, 第二个值表示labelIndex
      pickerOptionsList: {},
      inputWidth: 200,
      valLength: 0,
      pickerOptions: {
        disabledDate: (item) => {
          return item.getTime() > Date.now();
        },
      },
      // 选择标签数
      selectLabelCount: 0,
      // 计算人群数量
      population: 0,
      // 会员入会渠道标签的值
      memberChannel: [
        "1",
        "2,3,995,998",
        "101",
        "102",
        "103",
        "104",
        "105",
        "106",
        "113",
        "114",
        "115",
        "116",
        "117",
        "119",
        "120",
        "121",
        "130",
        "140",
        "150",
        "201",
        "202",
        "203",
        "212,213",
        "214",
        "215",
        "216",
        "217",
        "218",
        "219",
        "220",
        "301",
        "401",
        "405",
        "411",
        "420,666",
        "430",
        "501",
        "502",
        "503",
        "504",
        "601",
        "602",
        "603",
        "701",
        "801",
        "920",
        "999",
        "1003,1004,1234",
        "1301",
        "2011",
        "3021",
        "3022",
        "4021,4022,4023,402",
        "4031,403",
        "4032",
        "4033",
        "4034",
        "4035",
        "4036",
        "4037",
        "4041,4042,404",
      ],
      shopMemberType: "",
    };
  },
  created() {
    this.shopMemberType = this.shopInfo.shopMemberType;
    this.getLabelList();
  },

  mounted() {
    var dotDays = localStorage.getItem("dotDays");
    var nowDays = new Date().getDate();
    this.isShowNew = dotDays != nowDays;
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    shopInfo() {
      return this.$store.getters.shopInfo;
    },
  },
  methods: {
    // rangeTypeChange1(){
    //   console.log(this.valueData.minTime);
    //   console.log(this.valueData.maxTime);

    // },
    switchAllSecletStatus(label) {
      if (label.valueData.checkValue.length === this.memberChannel.length) {
        this.allSelectMembel = ["-1"];
      } else {
        this.allSelectMembel = [];
      }
    },
    // 会员入会渠道全选
    switchAllSelect(label) {
      if (
        this.allSelectMembel.length == "1" &&
        this.allSelectMembel[0] == "-1"
      ) {
        // 全选
        label.valueData.checkValue = this.memberChannel;
      } else {
        // 全不选
        label.valueData.checkValue = [];
      }
    },
    rangeTypeChange(label) {
      label.valueData.minValue = "";
      label.valueData.maxValue = "";
    },
    timeTypeChange(label) {
      label.valueData.maxTime = "";
      label.valueData.minTime = "";
    },
    // //按多选清空内部时间
    // areaSelectreset(){
    //   console.log(11111111111);
    //   this.label.valueData.minTime="";
    //   this.label.valueData.maxTime="";
    // },

    // 获取标签
    getLabelList() {
      // 店铺会员类型 shopMemberType
      var shopMemberType = this.shopMemberType;
      getLabel().then((res) => {
        let labelList = {};
        res &&
          res.data.forEach((key, index) => {
            let count = 0;
            key.searchWrap = true;
            key.isShow = false;

            key.data.forEach((item, index2) => {
              count += item.data.length;
              item.searchTitle = true;
              item.data.forEach((label, labelIndex) => {
                if (label.labelMeaning == "市") {
                  label.labelMeaning = "省市";
                }

                if (label.labelName == "opdata_base_profession") {
                  // 客户职业
                  var list1 = label.enumValues.filter((item) => {
                    return item.realValue !== "-1";
                  });
                  var list2 = label.enumValues.filter((item) => {
                    return item.realValue === "-1";
                  });
                  list1 = list1.sort((a, b) => {
                    return +a.realValue - +b.realValue;
                  });
                  label.enumValues = list1.concat(list2);

                  // label.enumValues = label.enumValues.sort((a, b) => {
                  //   return +a.realValue > +b.realValue
                  // })
                  // console.log('label.enumValues', label.enumValues)
                }

                if (label.labelName == "opdata_shop_member_channel") {
                  //会员入会渠道
                  label.labelDisplayType = 1;
                  label.hasEnumValue = true;
                  label.labelParamEsType = "terms";
                  label.labelParamRule = "0";
                  label.enumValues = [
                    { realValue: "1", fieldValue: "商详会员价" },
                    { realValue: "2,3,995,998", fieldValue: "测试渠道" }, // 2，3, 995,998
                    { realValue: "101", fieldValue: "卡包" },
                    { realValue: "102", fieldValue: "店铺首页" },
                    { realValue: "103", fieldValue: "app支付完成页" },
                    { realValue: "104", fieldValue: "App试用频道" },
                    { realValue: "105", fieldValue: "商详页" },
                    { realValue: "106", fieldValue: "积分兑换引导" },

                    { realValue: "113", fieldValue: "APP领券入会" },
                    { realValue: "114", fieldValue: "App品牌精选" },
                    { realValue: "115", fieldValue: "App导购码" },
                    { realValue: "116", fieldValue: "App门店码" },
                    { realValue: "117", fieldValue: "App品牌码" },
                    { realValue: "119", fieldValue: "APP Jpass支付完成页" },
                    { realValue: "120", fieldValue: "短信" },
                    { realValue: "121", fieldValue: "门店详情页" },

                    { realValue: "130", fieldValue: "APP-群聊(群内)" },
                    { realValue: "140", fieldValue: "APP-京东会员频道" },
                    { realValue: "150", fieldValue: "APP-客服咚咚" },
                    { realValue: "201", fieldValue: "开普勒" },
                    { realValue: "202", fieldValue: "Jzone" },
                    {
                      realValue: "203",
                      fieldValue: "小程序商详:会员价开卡楼层",
                    },

                    { realValue: "212,213", fieldValue: "小程序领券入会" }, // 212,213
                    { realValue: "214", fieldValue: "小程序品牌精选" },
                    { realValue: "215", fieldValue: "小程序导购码" },
                    { realValue: "216", fieldValue: "小程序门店码" },
                    { realValue: "217", fieldValue: "小程序品牌码" },
                    { realValue: "218", fieldValue: "小程序支付完成页" },
                    { realValue: "219", fieldValue: "小程序卡包" },
                    { realValue: "220", fieldValue: "门店帮导购" },

                    { realValue: "301", fieldValue: "金融app" },
                    { realValue: "401", fieldValue: "H5页面" },
                    // {realValue: '402', fieldValue: '社交魔方'},
                    // { realValue: "403", fieldValue: "大促活动" },
                    // {realValue: '404', fieldValue: '锦鲤抽奖'},
                    { realValue: "405", fieldValue: "m站商详:会员价开卡楼层" },
                    { realValue: "411", fieldValue: "快闪店" },
                    { realValue: "420,666", fieldValue: "联合开卡" },
                    { realValue: "430", fieldValue: "储值卡" },

                    { realValue: "501", fieldValue: "微q店铺首页" },
                    { realValue: "502", fieldValue: "微q商详" },
                    { realValue: "503", fieldValue: "微q结算页" },
                    { realValue: "504", fieldValue: "微q商详:会员价开卡楼层" },
                    { realValue: "601", fieldValue: "7-fresh" },
                    { realValue: "602", fieldValue: "溯源售后" },
                    { realValue: "603", fieldValue: "1元联合开卡" },
                    // {realValue: '666', fieldValue: '联合开卡'},

                    { realValue: "701", fieldValue: "商家自定义" },
                    { realValue: "801", fieldValue: "isv自定义" },
                    { realValue: "920", fieldValue: "通讯手机狂欢城" },
                    // {realValue: '995,998', fieldValue: '测试渠道'}, // 995,998
                    { realValue: "999", fieldValue: "默认渠道" },
                    { realValue: "1003,1004,1234", fieldValue: "分享" }, // 1003,1004,1234
                    { realValue: "1301", fieldValue: "APP-群聊(群入口)" },

                    { realValue: "2011", fieldValue: "开普勒-小程序拼券" },
                    { realValue: "3021", fieldValue: "h5砍价活动" },
                    { realValue: "3022", fieldValue: "小程序砍价活动" },
                    { realValue: "4021,4022,4023,402", fieldValue: "社交魔方" }, // 4021,4022,4023,402
                    { realValue: "4031,403", fieldValue: "大促活动" },
                    { realValue: "4032", fieldValue: "大促活动-互动会场" },
                    { realValue: "4033", fieldValue: "大促活动-预售会场" },
                    { realValue: "4034", fieldValue: "大促活动-狂欢城" },
                    { realValue: "4035", fieldValue: "大促活动-星店长" },
                    {
                      realValue: "4036",
                      fieldValue: "大促活动-20年618会员价会场",
                    },
                    {
                      realValue: "4037",
                      fieldValue: "大促活动-20年618isv互动会场",
                    },
                    { realValue: "4041,4042,404", fieldValue: "锦鲤抽奖" }, // 4041, 4042, 404
                  ];
                }

                label.valueData = {
                  minValue: "",
                  maxValue: "",
                  rangeType: 0, // 区间范围的值 0: 区间 1:大于 -1：小于
                  slideValue: 0, // 滑动组件的值
                  minTime: "",
                  maxTime: "",
                  itemInfo: [], // 商品信息
                  skuType: 0, // 0. 指定商品 1.指定sku
                  checkValue: [], // sku的值
                  value: "",
                  visible: false,
                  goodsList: [],
                };
                if (label.labelDisplayType == 4) {
                  // label.labelMeaning = "省市";
                  // console.log(index,index2);
                }
                label.searchItem = true;
                labelList[label.labelName] = {
                  name: label.labelMeaning,
                  enumValues: label.enumValues,
                  labelDisplayType: label.labelDisplayType,
                };

                // 根据会员标签隐藏某些属性
                console.log("shopMemberType:", shopMemberType);
                if (shopMemberType == "2" || shopMemberType == "4") {
                  // 隐藏 品牌会员、品牌会员等级、用户品牌积分余额、品牌会员开卡时间
                  if (
                    label.labelName == "opdata_shop_brand_member_flag" ||
                    label.labelName == "opdata_shop_brand_member_level" ||
                    label.labelName == "opdata_brand_points" ||
                    label.labelName == "opdata_shop_brand_bindingcard_tm"
                  ) {
                    label.isHide = true;
                  }
                } else if (shopMemberType == "3" || shopMemberType == "5") {
                  // 隐藏 店铺开卡会员、店铺会员等级、店铺积分余额、店铺会员开卡时间
                  if (
                    label.labelName == "opdata_shop_card_member_flag" ||
                    label.labelName == "opdata_shop_member_level" ||
                    label.labelName == "opdata_shop_points" ||
                    label.labelName == "opdata_shop_bindingcard_tm"
                  ) {
                    label.isHide = true;
                  }
                }
              });
            });
            key.labelCount = count;
          });
        this.dataList = res && res.data;
        this.dataList.forEach((key, index) => {
          key.data.forEach((item, index2) => {
            item.data.forEach((label, index3) => {
              // label.isNew = true;
              if (!this.isShowNew) {
                label.isNew = false;
              }
              if (label.labelDisplayType == 4) {
                // console.log(
                //   this.dataList[index].data[index2].data[index3].labelName
                // );
                let obj = this.dataList[index].data[index2].data[index3];
                this.limitTimeRange(obj);
              }
            });
          });
        });
        // console.log(this.dataList);
        if (!sessionStorage.getItem("labelList")) {
          sessionStorage.setItem("labelList", JSON.stringify(labelList));
        }
        // console.log(labelList);
      });
      console.log(this.dataList, 11111111111111);
    },
    // 左侧属性列表点击
    attrClick(label, item, labelItem) {
      // console.log(label);
      // console.log(item);
      // console.log(labelItem);
      // label.isNew ? (label.isNew = false) : '';
      if (label.isNew) {
        this.isNewNum++;
        label.isNew = false;
        if (this.isNewNum >= "5" && !this.isSaveLocation) {
          this.isSaveLocation = true;
          var days = new Date().getDate();
          localStorage.setItem("dotDays", days);
          console.log("days", days);
        }
      }
      label.valueData.visible
        ? this.selectLabelCount--
        : this.selectLabelCount++;
      label.valueData.visible = !label.valueData.visible;
      if (labelItem.data.some((i) => i.valueData.visible)) {
        item.isShow = true;
      } else {
        item.isShow = false;
      }

      if (label.valueData.visible === false) {
        label.valueData.checkValue = []; //类型2
        label.valueData.minValue = []; //类型3
        label.valueData.maxValue = [];
        label.valueData.goodsList = [];
        label.valueData.value = [];
        label.valueData.startValue = "";
        label.valueData.endValue = "";
        label.valueData.maxTime = "";
        label.valueData.minTime = "";
        this.labels = 0; //类型5
        this.provinces = [];
        this.goodsClass = [];
        if (label.valueData.skuType) {
          label.valueData.skuType = 0;
        }
        // console.log(label);
      }
      //判断表格是否为空
      try {
        this.dataList.forEach((item) => {
          item.data.forEach((item1) => {
            item1.data.forEach((item2) => {
              if (item2.valueData.visible == true) {
                throw new Error("End");
              } else {
                this.defaultShow = true;
              }
            });
          });
        });
      } catch (e) {
        if (e.message === "End") {
          this.defaultShow = false;
        } else {
          this.defaultShow = true;
        }
      }
    },
    setItem(key) {
      localStorage.setItem(key, JSON.stringify(new Date()));
    },
    // 保存按钮
    handleSave() {
      if (!this.form.name.trim()) {
        this.$message.info("请填写人群名称");
        return false;
      }

      if (!this.form.description.trim()) {
        this.$message.info("请填写人群描述");
        return false;
      }
      const strategy = this.showLimitAttr();

      const params = Object.assign(this.form, {
        strategy: JSON.stringify(strategy),
        type: 1,
      });
      // console.log(params);
      // return;
      // console.log();
      if (!params.strategy) {
        return;
      }
      if (params.strategy != "[]") {
        addMemberCrowd(params).then((res) => {
          if (res && res.code == 1) {
            this.setItem("isFresh");
            this.$message.success("保存成功");
            this.$store.commit("setRefresh", true);
            this.handleCancel(true);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.info("请编辑人群筛选条件");
      }
    },
    onChange(val) {
      // console.log(123123);
      // console.log(this.inputWidth);
      // console.log(val.length);
      // this.valLength = val.length

      if (val.length == 0) {
        this.inputWidth = 200;
      }
      if (val.length < 13) {
        return;
      }
      if (val.length - this.valLength > 25) {
        this.inputWidth = 240 + val.length * 10;
      }

      if (this.valLength < val.length) {
        this.inputWidth = 60 + val.length * 8;
      } else {
        this.inputWidth -= 9;
      }

      this.valLength = val.length;
    },

    // 计算人群按钮
    handlePeopleComputed() {
      const params = this.showLimitAttr();
      // console.log('params:', params)
      if (params) {
        compute({ strategy: JSON.stringify(params) }).then((res) => {
          if (res && res.code == 1) {
            this.population = res.data.count;
          }
          console.log(res);
        });
      }
    },
    // 取消按钮
    handleCancel(state) {
      state ? this.$emit("on-cancel", true) : this.$emit("on-cancel", false);
      this.form = {
        name: "",
        description: "",
      };
      this.selectLabelCount = 0;
      this.population = 0;
      this.dataList = null;
      this.getLabelList();
    },
    // 删除标签
    delLabel(label, item, labelItem) {
      // console.log(label)
      label.valueData.visible = false;
      if (labelItem.data.some((i) => i.valueData.visible)) {
        item.isShow = true;
      } else {
        item.isShow = false;
      }
      if (label.valueData.visible === false) {
        label.valueData.checkValue = []; //类型2
        label.valueData.minValue = []; //类型3
        label.valueData.maxValue = [];
        label.valueData.goodsList = [];
        label.valueData.startValue = "";
        label.valueData.endValue = "";
        label.valueData.value = "";
        label.valueData.maxTime = "";
        label.valueData.minTime = "";
        if (label.valueData.skuType) {
          label.valueData.skuType = 0;
        }
        this.labels = 0; //类型5
        if (label.labelMeaning == "省市") {
          this.provinces = [];
        }
        this.goodsClass = [];
        // console.log(label);
      }
      this.selectLabelCount--;
      //判断表格是否为空
      try {
        this.dataList.forEach((item) => {
          item.data.forEach((item1) => {
            item1.data.forEach((item2) => {
              if (item2.valueData.visible == true) {
                throw new Error("End");
              } else {
                this.defaultShow = true;
              }
            });
          });
        });
      } catch (e) {
        if (e.message === "End") {
          this.defaultShow = false;
        } else {
          this.defaultShow = true;
        }
      }
    },
    arrayIndexOf(item, arr) {
      if (Array.prototype.indexOf) {
        return arr.indexOf(item);
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return i;
          }
        }
      }
      return -1;
    },
    // 属性限制过滤相关
    showLimitAttr() {
      // 获取勾选的属性的值
      var valueData = [];

      this.dataList.forEach((dataItem) => {
        dataItem.data.forEach((labelItem) => {
          labelItem.data.forEach((item) => {
            if (item.valueData.visible) {
              valueData.push(item);
            }
          });
        });
      });
      // console.log("valueData", valueData);
      let tipText = "";
      let isFlag = true;
      let params = [];
      for (let i = 0; i < valueData.length; i++) {
        let item = valueData[i];
        let param = {};
        // 单选类型
        if (item.labelDisplayType == 0) {
          !item.valueData.value &&
            ((tipText = item.labelMeaning + "：没有选择单选项"),
            (isFlag = false));
          param.value = item.valueData.value;
        }
        // 复选框类型
        if (item.labelDisplayType == 1) {
          if (item.valueData.checkValue.length == 0) {
            tipText = item.labelMeaning + "：至少选一个";
            isFlag = false;
            break;
          }
          // 会员入会渠道

          if (item.labelName == "opdata_shop_member_channel") {
            var valueList = JSON.parse(
              JSON.stringify(item.valueData.checkValue)
            );
            var delItem = [];
            valueList.forEach((vItem, checkIndex) => {
              if (vItem == "2,3,995,998") {
                // 2,3 测试渠道
                // valueList.splice(this.arrayIndexOf(vItem, valueList), 1);
                delItem.push(vItem);
                valueList.push("2");
                valueList.push("3");
                valueList.push("995");
                valueList.push("998");
              } else if (vItem == "212,213") {
                // 212,213 小程序领券入会
                // valueList.splice(this.arrayIndexOf(vItem, valueList), 1);
                delItem.push(vItem);
                valueList.push("212");
                valueList.push("213");
              } else if (vItem == "420,666") {
                // 420,666 联合开卡
                // valueList.splice(this.arrayIndexOf(vItem, valueList), 1);
                delItem.push(vItem);
                valueList.push("420");
                valueList.push("666");
              } else if (vItem == "1003,1004,1234") {
                // 1003,1004,1234 分享
                // valueList.splice(this.arrayIndexOf(vItem, valueList), 1);
                delItem.push(vItem);
                valueList.push("1003");
                valueList.push("1004");
                valueList.push("1234");
              } else if (vItem == "4021,4022,4023,402") {
                // 4021,4022,4023,402 社交魔方
                // valueList.splice(this.arrayIndexOf(vItem, valueList), 1);
                delItem.push(vItem);
                valueList.push("4021");
                valueList.push("4022");
                valueList.push("4023");
                valueList.push("402");
              } else if (vItem == "4031,403") {
                // 4031,403 大促活动
                // valueList.splice(this.arrayIndexOf(vItem, valueList), 1);
                delItem.push(vItem);
                valueList.push("4031");
                valueList.push("403");
              } else if (vItem == "4041,4042,404") {
                // 4041, 4042 锦鲤抽奖
                // valueList.splice(this.arrayIndexOf(vItem, valueList), 1);
                delItem.push(vItem);
                valueList.push("4041");
                valueList.push("4042");
                valueList.push("404");
              }
            });
            delItem.forEach((delItem, delIndex) => {
              valueList.splice(this.arrayIndexOf(delItem, valueList), 1);
            });
            // console.log('valueList', valueList);
            param.value = valueList;
          } else {
            param.value = item.valueData.checkValue;
          }
        }
        // 滑块类型
        if (item.labelDisplayType == 2) {
          !item.valueData.slideValue &&
            ((tipText = item.labelMeaning + "：请滑动取值"), (isFlag = false));
          param.value = item.valueData.slideValue;
        }
        // 数字范围选择类型
        if (item.labelDisplayType == 3) {
          if (item.valueData.rangeType == "0") {
            // 区间
            if (
              item.valueData.minValue != "" &&
              item.valueData.maxValue != ""
            ) {
              if (+item.valueData.minValue > +item.valueData.maxValue) {
                tipText = item.labelMeaning + "：开始值不能大于结束值";
                isFlag = false;
                break;
              }
            } else if (item.valueData.minValue + "" == "") {
              // console.log(item);
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxValue + "" == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
          } else if (item.valueData.rangeType == "-1") {
            if (item.valueData.maxValue + "" == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            }
          } else if (
            item.valueData.rangeType == "1" &&
            item.valueData.minValue == ""
          ) {
            tipText = item.labelMeaning + "：结束值不能为空";
            isFlag = false;
            break;
          }
          param.startValue = item.valueData.minValue;
          param.endValue = item.valueData.maxValue;
          // 小于等于选项，startValue需要默认值0
          if (item.valueData.rangeType == "-1") {
            param.startValue = "0";
          }
        }
        // 时间范围选择类型
        if (item.labelDisplayType == 4) {
          // console.log(item.valueData.minTime, item.valueData.maxTime);
          if (item.valueData.rangeType == 0) {
            // 区间
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
          } else if (item.valueData.rangeType == 2) {
            // 小于
            if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
            param.endValue = item.valueData.maxTime;
          } else if (item.valueData.rangeType == 1) {
            // 大于
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
          } else if (item.valueData.rangeType == 3) {
            if (item.valueData.minTime == "" && item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：不能为空";
              isFlag = false;
              break;
            } else if (
              item.valueData.minTime != "" &&
              item.valueData.maxTime != "" &&
              +item.valueData.minTime > +item.valueData.maxTime
            ) {
              tipText = item.labelMeaning + "：开始值不可大于结束值";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
          } else {
            if (item.valueData.value == "") {
              tipText = item.labelMeaning + "：不能为空";
              isFlag = false;
              break;
            }
            param.value = item.valueData.value.join(",");
          }
          param.timeSelectType = item.valueData.rangeType + "";
        }
        // 指定商品 指定sku类型
        if (item.labelDisplayType == 5) {
          if (item.valueData.skuType == 0) {
            item.valueData.goodsList.length == 0 &&
              ((tipText = item.labelMeaning + "：请选择商品"),
              (isFlag = false));
            param.itemInfo = item.valueData.goodsList;
            param.value = item.valueData.goodsList.map((i) => i.skuId + "");
          } else {
            !item.valueData.value.trim() &&
              ((tipText = item.labelMeaning + ": 请输入商品sku"),
              (isFlag = false));
            // param.value = [item.valueData.value];
            param.value = item.valueData.value.split(",");
          }
          // param.skuType = item.valueData.skuType;
        }
        // 商品类目
        if (item.labelDisplayType == 6) {
          if (item.valueData.value == "") {
            tipText = item.labelMeaning + ": 请至少选择一项";
            isFlag = false;
          }
          param.value = item.valueData.value;
        }
        // 选择省市
        if (item.labelDisplayType == 7) {
          if (item.valueData.value == "") {
            tipText = item.labelMeaning + ": 请至少选择一项";
            isFlag = false;
          }
          param.value = item.valueData.value;
        }
        param = Object.assign(param, {
          group: item.labelGroup,
          tagname: item.labelName,
          type: item.labelParamEsType,
          paramRules: String(item.labelParamRule),
        });
        params.push(param);
      }
      if (!isFlag) {
        this.$message.info(tipText);
        return;
      }
      return params;
    },
    // 标签名查询
    handleSearch() {
      this.searchStatus = true;
      var dataList = JSON.parse(JSON.stringify(this.dataList));

      dataList.forEach((dataItem) => {
        var i = 0;
        dataItem.data.forEach((labelItem) => {
          labelItem.data.forEach((item) => {
            if (item.labelMeaning.indexOf(this.searchValue) != "-1") {
              item.searchItem = true;
              i++;
            } else {
              item.searchItem = false;
            }
          });
          i > 0
            ? (labelItem.searchTitle = true)
            : (labelItem.searchTitle = false);
        });
        i > 0 ? (dataItem.searchWrap = true) : (dataItem.searchWrap = false);
      });

      this.dataList = dataList;
    },
    // 时间范围清楚
    clearTime(dataIndex, labelIndex, index) {
      var dataList = JSON.parse(JSON.stringify(this.dataList));
      let obj = dataList[dataIndex].data[labelIndex].data[index];
      dataList[dataIndex].data[labelIndex].data[index].valueData.minTime = "";
      dataList[dataIndex].data[labelIndex].data[index].valueData.maxTime = "";
      this.dataList = dataList;
      this.limitTimeRange(obj);
    },

    // 时间范围限制
    limitTimeRange(obj) {
      this.$set(
        this.pickerOptionsList,
        "pickerOptions" + obj.labelName + "start",
        {
          disabledDate: (time) => {
            if (!obj.valueData.maxTime) {
              return time.getTime() > Date.now();
            } else {
              let endTime = new Date(obj.valueData.maxTime).getTime();
              // 最小选择时间   (时间跨度不能大于一年时间)
              // let minTime = endTime - 365 * 24 * 3600 * 1000;
              let minTime = endTime;

              return (
                time.getTime() > minTime ||
                time.getTime() > Date.now()
              );
            }
          },
        }
      );
      this.$set(
        this.pickerOptionsList,
        "pickerOptions" + obj.labelName + "end",
        {
          disabledDate: (time) => {
            if (!obj.valueData.minTime) {
              // return time.getTime() > Date.now() - 8.64e7;
              return time.getTime() > Date.now();
            } else {
              let startTime = new Date(obj.valueData.minTime).getTime();
              // 最大选择时间  （时间跨度不能大于一年）
              // let maxTime = startTime + 365 * 24 * 3600 * 1000;

              return (
                time.getTime() < startTime - 8.64e7 ||
                time.getTime() > Date.now()
                // || time.getTime() > maxTime - 8.64e7
              );
            }
          },
        }
      );
    },

    // 标签查询结果返回
    goBack() {
      this.dataList.forEach((dataItem) => {
        dataItem.searchWrap = true;
        dataItem.data.forEach((label) => {
          label.searchTitle = true;
          label.data.forEach((item) => {
            item.searchItem = true;
          });
        });
      });
      this.searchStatus = false;
      this.searchValue = "";
    },
    // 显示商品类目弹窗
    showCategoryDialog(dataIndex, labelIndex, index, value) {
      this.currentIndex = [dataIndex, labelIndex, index];
      if (value.length > 0) {
        var goodsClass = [];
        value.forEach((item) => {
          var temp = {
            id: item,
          };
          goodsClass.push(temp);
        });
      }
      this.goodsClass = goodsClass;
      this.goodsCategoryDialog = true;
    },
    // 关闭商品类目弹窗
    closeCategory(state, val) {
      this.goodsCategoryDialog = false;
      if (state) {
        this.dataList[this.currentIndex[0]].data[this.currentIndex[1]].data[
          this.currentIndex[2]
        ].valueData.value = val.map((i) => i.id);
        this.goodsClass = val;
      }
    },
    // 限制skuid 最多输入30个
    limitSkuId(dataIndex, labelIndex, index) {
      var value = this.dataList[dataIndex].data[labelIndex].data[index]
        .valueData.value;
      var reg = /[^\d,，\s]/g
       if (reg.test(value)) {
        value = value.replace(reg, "");
      }
      // console.log('value:', value.replace(/\s+/g, ""))
      this.dataList[dataIndex].data[labelIndex].data[index].valueData.value = value.replace(/\s+/g, "");
      // if (value.replace(/[^\d\,]/g, "").split(",").length > 30) {
      //   this.dataList[dataIndex].data[labelIndex].data[
      //     index
      //   ].valueData.value = value.slice(0, value.length - 1);
      // }
    },

    getLocation(val, state) {
      this.dataList[this.currentIndex[0]].data[this.currentIndex[1]].data[
        this.currentIndex[2]
      ].valueData.value = val;
      this.provinces = val;
    },
    // 选择省市
    handleSelectCity(dataIndex, labelIndex, index) {
      this.currentIndex = [dataIndex, labelIndex, index];
      this.cityShow = true;
    },
    // 显示选择商品弹窗
    showSelectGoods(dataIndex, labelIndex, index) {
      this.currentIndex = [dataIndex, labelIndex, index];
      this.returnSelectGoods = this.dataList[dataIndex].data[labelIndex].data[
        index
      ].valueData.goodsList;
      // return
      this.goodsState = true;
    },
    // 商品组件回调
    selectGoodsChange(val) {
      this.goodsState = false;
      if (val !== false) {
        // this.goodsStateLength = val.length;
        // this.postForm.itemList = val;
        this.returnSelectGoods = val;
        var dataList = JSON.parse(JSON.stringify(this.dataList));
        dataList[this.currentIndex[0]].data[this.currentIndex[1]].data[
          this.currentIndex[2]
        ].valueData.goodsList = val;
        this.dataList = dataList;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #f56c6c;
  border-radius: 50%;
  vertical-align: 10%;
}
/deep/ .form-value .el-input__suffix {
  right: -45px;
}
.filter-box {
  padding: 20px;
  .filter-content {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    background-color: #fff;
    padding: 20px 28px 0 28px;
    .search-form {
      .form-item {
        display: inline-block;
        // margin-right: 20px;
        .form-label {
          display: inline-block;
          text-align: right;
          width: 98px;
        }
        .form-value {
          display: inline-block;
        }
      }
      .form-right {
        float: right;
        span {
          margin-right: 12px;
        }
      }
      &::after {
        content: "";
        clear: both;
        display: block;
        width: 0;
        height: 0;
        overflow: hidden;
      }
    }
  }

  .attr-box {
    position: relative;
    height: 700px;
    margin-top: 10px;
    padding: 20px 28px 20px 28px;
    font-size: 14px;
    border: 1px solid #efefef;
    .attr-leftbigbox {
      box-sizing: border-box;
      padding-right: 20px;
      position: absolute;
      .search-line {
        margin-bottom: 10px;
        position: relative;
        width: 360px;
        /deep/.el-input {
          input {
            border-radius: 32px;
          }
        }
        i {
          color: #cccccc;
          font-size: 14px;
          line-height: 32px;
          position: absolute;
          right: 10px;
          top: 0;
          cursor: pointer;
        }
      }
      .attr-left {
        // display: inline-block;
        box-sizing: border-box;
        padding-right: 20px;
        position: absolute;
        width: 390px;
        max-height: 638px;
        overflow-y: auto;
        .search-result {
          padding-bottom: 10px;
          padding-top: 15px;
          border-bottom: 1px solid #eeeeee;
          display: flex;
          justify-content: space-between;
          color: #333;
          .go-back {
            color: rgb(254, 77, 69);
            cursor: pointer;
          }
        }
        .attr-item-wrap {
          box-sizing: border-box;
          border: 1px solid #eeeeee;
          padding: 0 8px;
          margin-top: 20px;
          h4 {
            height: 40px;
            line-height: 38px;
            border-bottom: 1px solid #f0f0f0;
            margin: 0;
            text-align: center;
            font-weight: bold;
            font-size: 14px;
            color: #333;
          }
        }
        .attr-item-box {
          margin-bottom: 7px;
          .attr-title {
            // height: 45px;
            // line-height: 45px;
            color: #333;
            font-weight: 500;
            padding-bottom: 10px;
            padding-top: 15px;
            // background-color: #f4f5f9;
            // padding-left: 20px;
          }
          .attr-list {
            padding-top: 5px;
            .over-ellipsis {
              height: 32px;
              line-height: 32px;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: center;
            }
            .attr-padd {
              box-sizing: border-box;
              width: 50%;
              height: 32px;
              line-height: 32px;
              cursor: pointer;
              display: inline-block;
              position: relative;
              color: #333;
              text-align: center;
              margin: 0 0 8px 0;
              &:nth-child(1n) {
                padding: 0 5px 0 0;
              }
              &:nth-child(2n) {
                padding: 0 0 0 5px;
              }
              .attr-item {
                position: relative;
                box-sizing: border-box;
                padding: 0 5px;
                background-color: #f6f6f6;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                img {
                  position: absolute;
                  bottom: 0;
                  right: 0;
                  display: none;
                }
                &.active {
                  color: #fe4d45;
                  border: 1px solid #fe4d45;
                  background-color: #fff;
                  .over-ellipsis {
                    color: #fe4d45;
                  }
                  img {
                    display: block;
                  }
                }
              }
            }
          }
        }
      }
    }
    .attr-rightbigbox {
      display: inline-block;
      vertical-align: text-top;
      // border: 1px solid #efefef;
      position: absolute;
      left: 430px;
      right: 0;
      .tip-line {
        color: #333;
        margin-bottom: 10px;
        .icon_i {
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 14px;
          background-color: #fe8f8a;
          // vertical-align: middle;
          color: #fff;
          font-size: 14px;
          text-align: center;
          line-height: 14px;
          font-weight: bold;
          margin-right: 8px;
        }
      }
      .attr-right {
        display: inline-block;
        vertical-align: text-top;
        // border: 1px solid #efefef;
        position: absolute;
        left: 0px;
        right: 0;
        max-height: 638px;
        overflow: auto;
        // background-color: #000;
        .module-title {
          font-size: 14px;
          color: #333;
          font-weight: 500;
          padding: 16px 0;
          border-bottom: 1px solid #eeeeee;
          margin-bottom: 20px;
        }
        .first-title {
          color: #666666 !important;
          font-size: 14px !important;
          line-height: 17px !important;
          margin-left: 10px !important;
          margin-top: 14px !important;
        }
        .attr-content-item {
          box-sizing: border-box;
          padding-right: 22px;
          position: relative;
          margin-bottom: 16px;
          .del-btn {
            position: absolute;
            right: -64px;
            top: 31px;
            cursor: pointer;
            i {
              font-size: 33px;
              color: #cccccc;
            }
          }

          .title-line {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 48px;
            padding: 0 28px 0 20px;
            background-color: #f6f6f6;
            color: #333;
            .handle {
              display: flex;
              align-items: center;
              .assistant {
                margin-right: 16px;
                width: 98px;
                height: 28px;
                line-height: 26px;
                background: #ffffff;
                border: 1px solid #fe4d45;
                border-radius: 3px;
                outline: none;
                color: #fe4d45;
                cursor: pointer;
                transition: all 0.3s;
                &:hover {
                  background-color: #fe4d45;
                  color: #fff;
                  opacity: 0.8;
                }
              }
              .delTxt {
                color: #fe4d45;
                font-size: 14px;
                cursor: pointer;
              }
            }
          }
          .labelExplain {
            box-sizing: border-box;
            margin: 0;
            padding: 10px 0;
            border-bottom: 1px solid #eeeeee;
            line-height: normal;
            color: #999999;
            font-size: 13px;
          }
          .radio-content {
            line-height: 48px;
          }
          .area-select {
            padding-top: 8px;
            padding-bottom: 8px;
            .to-text {
              margin: 0 8px;
            }
            .el-input {
              width: 125px;
            }
            .el-select {
              margin-right: 20px;
              width: 136px;
            }
          }
          .select-city-box {
            padding-top: 8px;
            padding-bottom: 8px;
            /deep/ .el-button {
              width: auto !important;
            }
          }
          .goods-sku-box {
            padding-top: 8px;
            padding-bottom: 8px;
            /deep/ .el-button {
              width: auto !important;
            }
            span {
              margin-right: 8px;
            }
          }
          // .designated-goods {
          //   span {
          //     margin-right: 8px;
          //   }
          //   .el-input {
          //     width: 280px;
          //   }
          // }
          .content {
            padding-left: 20px;
            border: 1px solid #f6f6f6;
          }
          .slider.content {
            padding-left: 38px;
            padding-top: 8px;
            padding-bottom: 8px;
          }
          .time-range {
            padding-top: 8px;
            padding-bottom: 8px;
            // .el-input{
            //   width: 240px;
            // }
            // .to-text{
            //   padding: 0 8px;
            // }
            // /deep/.el-input__inner{
            //   padding-left: 30px!important;
            //   box-sizing: border-box;
            // }
          }
        }
        .attr-content-item:first-child {
          margin-top: 16px;
        }
      }
    }
  }
}
.tree-box {
  max-height: 300px;
  overflow: auto;
}
.btn-group {
  text-align: right;
  .el-button {
    width: 96px;
  }
}
/**  底部计算保存按钮 */
.footer-btn-box {
  height: 80px;
  padding: 23px 0 21px 28px;
  background-color: #fff;
  font-size: 14px;
  .text-label {
    display: inline-block;
    vertical-align: middle;
    color: #333;
  }
  .computed-btn {
    width: 82px;
    height: 28px;
    vertical-align: middle;
    margin-right: 8px;
    color: #fe4d45;
    background-color: #fff;
    border: 1px solid #fe4d45;
    &:hover {
      color: #ffffff;
      background-color: #fe4d45;
    }
  }
  .cancel-btn {
    width: 148px;
    height: 36px;
    // margin-left: 314px;
    color: #666666;
    float: right;
    background-color: #fff;
    border: 1px solid #dddddd;
    &:hover {
      color: #fe4d45;
      background-color: #fff4f4;
      border: 1px solid #fe4d45;
    }
  }
  .save-btn {
    width: 188px;
    height: 36px;
    float: right;
    margin-left: 8px;
    color: #fff;
    margin-right: 25px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
    }
  }
}
.popoverWrap {
  .popoverItem {
    display: flex;
    // align-items: center;
    margin: 20px;
    &:last-child {
      margin: 20px;
    }
    img {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
    .desc {
      display: flex;
      flex-direction: column;
      span {
        &:first-child {
          font-size: 16px;
          color: #000;
          margin-bottom: 2px;
        }
        &:last-child {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
}
</style>
